import { useBreakpoints, useStorage } from '@vueuse/core';
import { watch } from '@vue/composition-api/dist/vue-composition-api';
import { mainStore } from 'partners-widget-core';

const useDeviceCheck = () => {
  const breakpoints = useBreakpoints({
    mobile: mainStore.store.env.mobileBreakpoint || 1025,
  });
  const smAndLarger = breakpoints.greater('mobile');

  const checkThreshold = () => (smAndLarger.value ? 'desktop' : 'mobile');

  const storage = useStorage('wlIsMobile', checkThreshold());

  watch(
    () => smAndLarger.value,
    () => {
      storage.value = checkThreshold();
    }
  );

  return {
    smAndLarger,
  };
};

export default useDeviceCheck;
